<template>
  <div>
    <el-row :gutter="20" type="flex" class="todo-stat">
      <el-col>
        <todo-total :value="statistics.totalSales" class="todo-stat-total-sales">
          <span v-html="$t('statistics.totalSales')" />
        </todo-total>
      </el-col>
      <el-col>
        <todo-total :value="statistics.sessionsCanceled | thousandsFormat" class="todo-stat-total-canceled">
          <span v-html="$t('statistics.sessionsCanceled')" />
        </todo-total>
      </el-col>
      <el-col>
        <todo-total :value="statistics.sessionsBooked | thousandsFormat" class="todo-stat-total-booked">
          <span v-html="$t('statistics.sessionsBooked')" />
        </todo-total>
      </el-col>
      <el-col>
        <todo-total :value="statistics.sessionsConfirmed | thousandsFormat" class="todo-stat-total-confirmed">
          <span v-html="$t('statistics.sessionsConfirmed')" />
        </todo-total>
      </el-col>
      <el-col>
        <todo-total :value="statistics.providersProfileViews | thousandsFormat" class="todo-stat-total-view">
          <span v-html="$t('statistics.providersProfileViews')" />
        </todo-total>
      </el-col>
    </el-row>
    <br>
    <h1 class="todo-stat-h1">
      {{ $t('pages.payed') }}
    </h1>
    <el-row>
      <el-table
        :data="payed"
        style="width: 100%"
        class="no-blue"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row :gutter="20" type="flex" class="todo-stat custom-form">
              <el-col :md="8" :lg="8" :xl="8">
                <el-row>
                  <h2>{{ $t('payed.consumer') }}</h2>
                  <h3>{{ props.row.consumerName }}</h3>
                  <span>{{ $t('payed.documentType') }}: <strong>{{ props.row.consumerDocumentType }}</strong></span>
                  <span>{{ $t('payed.document') }}: <strong>{{ props.row.consumerDocument }}</strong></span>
                </el-row>
                <div class="dashed" />
                <el-row>
                  <h2>{{ $t('payed.professional') }}</h2>
                  <h3>{{ props.row.professionalName }}</h3>
                  <span>{{ $t('payed.documentType') }}: <strong>{{ props.row.professionalDocumentType }}</strong></span>
                  <span>{{ $t('payed.document') }}: <strong>{{ props.row.professionalDocument }}</strong></span>
                </el-row>
              </el-col>
              <el-col :md="8" :lg="8" :xl="8">
                <el-row>
                  <h2>{{ $t('payed.amount') }}</h2>
                  <h3>${{ props.row.amount }}</h3>
                  <span>{{ $t('payed.transactionDate') }}: <strong>{{ props.row.transactionDate }}</strong></span>
                  <span>{{ $t('payed.paymentType') }}: <strong>{{ props.row.transactionTypeText }}</strong></span>
                </el-row>
                <div class="dashed" />
                <el-row>
                  <h2>{{ $t('payed.service') }}</h2>
                  <h4>{{ props.row.serviceDescription }}</h4>
                  <span>{{ $t('payed.dateAndTime') }}: <strong>{{ props.row.serviceDate }}</strong></span>
                </el-row>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('payed.transactionAmount')"
          prop="amount"
        />
        <el-table-column
          :label="$t('payed.transactionDate')"
          prop="transactionDate"
        />
        <el-table-column
          :label="$t('payed.payedWith')"
          prop="transactionTypeText"
        />
        <el-table-column
          :label="$t('payed.client')"
          prop="consumerName"
        />
      </el-table>
    </el-row>
  </div>
</template>

<script>
  import { getBookingStatistics } from '@/api/statistics'
  import TodoTotal from './Total.vue'

  export default {
    components: {
      'todo-total': TodoTotal
    },

    data() {
      return {
        listLoading: true,
        statistics: {
          totalSales: '',
          sessionsCanceled: 0,
          sessionsBooked: 0,
          sessionsConfirmed: 0,
          providersProfileViews: 0
        },
        payed: []
      }
    },

    created() {
      this.getStatistics()
    },

    methods: {
      async getStatistics() {
        this.listLoading = true

        const { data } = await getBookingStatistics()

        this.statistics.totalSales = data.total_sales
        this.statistics.sessionsCanceled = parseInt(data.sessions_canceled)
        this.statistics.sessionsBooked = parseInt(data.sessions_booked)
        this.statistics.sessionsConfirmed = parseInt(data.sessions_confirmed)
        this.statistics.providersProfileViews = parseInt(data.providers_profile_views)
        this.payed = data.payed

        this.listLoading = false
      }
    }
  }
</script>

<style lang="scss">
  .todo-stat {
    .todo-stat-total-sales {
      background: #3DCD54;
    }

    .todo-stat-total-canceled {
      background: #EF5757;
    }

    .todo-stat-total-booked {
      background: #8857EF;
    }

    .todo-stat-total-confirmed {
      background: #5781EF;
    }

    .todo-stat-total-view {
      background: #EA53A4;
    }
    .todo-stat-h1 {
      margin-top: 1rem;
    }
  }
  .no-blue .el-table__body tr:hover > td {
     background: #f6f6f6 !important;
  }
  .custom-form {
    h2 {
      display: block;
    }
    span {
      display: block;
    }
    .dashed {
      border-top: 2px dashed rgb(200, 200, 200);
      margin-top: 1.3rem;
      margin-bottom: 1.3rem;
    }
  }
</style>
